export default "__VITE_ASSET__DG0Vne1y__"